import axios from "axios";
import { url } from "../baseUrl";

export const IdentityStore = {
  state: {
    allusers: [],
    allteams: []
  },
  mutations: {
    getAllUsers(state, data) {
      data.map(item => {
        if (item.last_login) {
          let initialSubmitted = item.last_login;
          let initialDate = initialSubmitted.split("T")[0];
          let initialTime = initialSubmitted.split("T")[1].split(".")[0];
          let date = new Date(initialDate);
          let listDate = date.toUTCString().split(" ");
          let hours = initialTime.split(":")[0];
          let mins = initialTime.split(":")[1];
          let ampm = hours >= 12 ? "p.m." : "a.m.";
          hours = hours % 12;
          hours = hours ? hours : 12;
          item.last_login =
            listDate[2] +
            " " +
            listDate[1] +
            ", " +
            listDate[3] +
            ", " +
            hours +
            ":" +
            mins +
            " " +
            ampm;
        }
      });
      state.allusers = data.map(item => ({
        id: item.id,
        is_active: item.is_active,
        role: item.role,
        fullname: item.fullname,
        team: item.team,
        email: item.email,
        phone: item.phone_number,
        lastlogin: item.last_login,
        timezone: item.timezone,
        country: item.country,
        language: item.language,
        hunted: item.v_hunted,
        critical_hunted: item.critical_v_hunted,
        gender: item.gender,
        configfiles: item.uploads,
        title: item.title,
        address: item.address,
        company: item.company.name
      }));
    },
    getAllTeams(state, data) {
      state.allteams = data;
    },

    editUserAccount(state, data) {
      state.allusers.map(user => {
        if (user.id == data.id) {
          user.fullname = data.fullname;
          user.gender = data.gender;
          user.title = data.title;
          user.address = data.address;
          user.country = data.country;
          user.language = data.language;
          user.timezone = data.timezone;
          user.role = data.role;
        }
      });
    },
    pauseUserAccount(state, data) {
      state.allusers.map(user => {
        if (user.id == data.id) {
          user.is_active = data.is_active;
        }
      });
    },
    addUserToTeam(state, data) {
      state.allusers.map(user => {
        if (user.id == data.id) {
          user.team = Object.assign({}, data.team);
        }
      });
    },
    removeUserFromTeam(state, data) {
      state.allusers.map(user => {
        if (user.id == data.id) {
          user.team = Object.assign({}, data.team);
        }
      });
    }
  },
  actions: {
    inviteUsers(context, data) {
      let auth_token = localStorage.getItem("auth_token");      
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/idm/inviteusers/",
          headers: {
            Authorization: "Token " + auth_token
          },
          data: data,
          method: "POST"
        })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error.response);
          });
      });
    },
    getAllUsers(context) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/idm/allusers/",
          headers: {
            Authorization: "Token " + auth_token
          },
          method: "GET"
        })
          .then(response => {
            context.commit("getAllUsers", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getAllTeams(context) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/accounts/teams/",
          headers: {
            Authorization: "Token " + auth_token
          },
          method: "GET"
        })
          .then(response => {
            context.commit("getAllTeams", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    changeUserPwd(context, data) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/idm/changepassword/",
          headers: {
            Authorization: "Token " + auth_token
          },
          data: data,
          method: "POST"
        })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    editUserAccount(context, data) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/idm/editaccount/",
          headers: {
            Authorization: "Token " + auth_token
          },
          data: data,
          method: "POST"
        })
          .then(response => {
            context.commit("editUserAccount", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    pauseUserAccount(context, data) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/idm/pauseaccount/",
          headers: {
            Authorization: "Token " + auth_token
          },
          data: data,
          method: "POST"
        })
          .then(response => {
            context.commit("pauseUserAccount", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    addUserToTeam(context, data) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/idm/addtoteam/",
          headers: {
            Authorization: "Token " + auth_token
          },
          data: data,
          method: "POST"
        })
          .then(response => {
            context.commit("addUserToTeam", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    removeUserFromTeam(context, data) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/idm/removefromteam/",
          headers: {
            Authorization: "Token " + auth_token
          },
          data: data,
          method: "POST"
        })
          .then(response => {
            context.commit("removeUserFromTeam", response.data);
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    deleteAccount(context, data) {
      let auth_token = localStorage.getItem("auth_token");
      return new Promise((resolve, reject) => {
        axios({
          url: url.baseUrl + "/idm/deleteaccount/",
          headers: {
            Authorization: "Token " + auth_token
          },
          data: data,
          method: "POST"
        })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};
